import { render, staticRenderFns } from "./CommunicationAdd.vue?vue&type=template&id=9c3e830a&"
import script from "./CommunicationAdd.vue?vue&type=script&lang=ts&"
export * from "./CommunicationAdd.vue?vue&type=script&lang=ts&"
import style0 from "./CommunicationAdd.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports